import LeadFinderSubscriptionPlan from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";
import TerritoryAddOnServiceVariation from "@mapmycustomers/shared/enum/TerritoryAddOnServiceVariation";
import Organization from "@mapmycustomers/shared/types/Organization";

import Feature from "@app/enum/Feature";

export type AddOnServices = Organization["addOnServices"];

export const leadFinderPlanByFeature: Partial<Record<Feature, LeadFinderSubscriptionPlan>> = {
  [Feature.LEAD_FINDER_ADVANCED]: LeadFinderSubscriptionPlan.ADVANCED,
  [Feature.LEAD_FINDER_BASIC]: LeadFinderSubscriptionPlan.BASIC,
  [Feature.LEAD_FINDER_ELITE]: LeadFinderSubscriptionPlan.ELITE,
  [Feature.LEAD_FINDER_PRO]: LeadFinderSubscriptionPlan.PRO,
  [Feature.LEAD_FINDER_STARTER]: LeadFinderSubscriptionPlan.STARTER,
};

const isFeatureEnabled = (feature: Feature, addOnServices: AddOnServices): boolean => {
  switch (feature) {
    case Feature.ADVANCED_ROUTING:
      return !!addOnServices.advancedRouting;
    // All three Field Intelligence cards are gated by the one add-on, so they are always owned
    // together or unowned together.
    case Feature.AI_EXECUTIVE_SUMMARIES:
    case Feature.BESPOKE_REVENUE_INTELLIGENCE:
    case Feature.REP_COACHING:
      return !!addOnServices.coachingAndInsights;
    case Feature.AI_FIELD_AGENT:
      return !!addOnServices.aiFeatures;
    case Feature.BUSINESS_CARD_SCANNER:
      return !!addOnServices.businessCardScanner;
    case Feature.CUSTOM_DASHBOARDS:
      return addOnServices.cumul === true;
    case Feature.DATA_MERGING:
      return !!addOnServices.dupeCheck;
    case Feature.DEMOGRAPHICS:
      return !!addOnServices.demographicData;
    // Sold as one package with two halves; either half means the org has it.
    case Feature.EFFICIENCY_PACKAGE:
      return !!addOnServices.efficiencyReporting || !!addOnServices.fieldView;
    case Feature.EMAIL:
      return !!addOnServices.emailService;
    case Feature.HEALTHCARE_DATA:
      return !!addOnServices.healthcareData?.enabled;
    case Feature.LEAD_FINDER_ADVANCED:
    case Feature.LEAD_FINDER_BASIC:
    case Feature.LEAD_FINDER_ELITE:
    case Feature.LEAD_FINDER_PRO:
    case Feature.LEAD_FINDER_STARTER:
      return addOnServices.leadGen === leadFinderPlanByFeature[feature];
    case Feature.MILEAGE_TRACKER:
      return !!addOnServices.mileageTracking;
    case Feature.ONBOARDING:
      return !!addOnServices.userGuides;
    case Feature.PHI:
      return !!addOnServices.hipaaEnabled;
    case Feature.RESOURCES:
      return !!addOnServices.pinnedResource;
    case Feature.SMART_TERRITORIES:
      return addOnServices.territories === TerritoryAddOnServiceVariation.FULL;
    case Feature.TERRITORIES:
      return addOnServices.territories !== TerritoryAddOnServiceVariation.OFF;
  }
};

export default isFeatureEnabled;
